export const setUrlHash = (type) => {
  // console.log('TYPE', type);
  // const newHash = window.location.hash.replace(/#.*$/, '#' + type);
  // history.replaceState('', document.title, newHash);
  if (history.replaceState) {
    history.replaceState({}, '', '#' + type);
  } else {
    console.log('else');
    window.location.hash = '#' + type;
  }
}

export const removeUrlHash = () => {
  const noHashURL = window.location.href.replace(/#.*$/, '');
  window.history.replaceState('', document.title, noHashURL);
}
